'use client';

import { useState } from 'react';
import { Info } from 'lucide-react';
import { NoA2ModelsModal } from './NoA2ModelsModal';

/**
 * Full-width banner displayed at the top of NAM tone detail pages when the
 * tone has no A2 models. Visual style mirrors `ListeningTestBanner` so it
 * stacks naturally with the other top-of-page banners. Clicking opens the
 * No-A2 modal — the modal lives inside this component so the page only
 * needs to render `<NoA2ModelsBanner />`.
 */
const NoA2ModelsBanner = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(true);
          }
        }}
        style={{ cursor: 'pointer' }}
        className="relative text-white bg-zinc-900"
      >
        <div className="max-w-6xl px-3 sm:px-6 mx-auto flex flex-row gap-4 py-2 justify-center items-center">
          <Info size={24} className="text-zinc-400 flex-shrink-0" />
          <span className="text-sm sm:text-base font-bold">No A2 Models</span>
        </div>
      </div>
      <NoA2ModelsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default NoA2ModelsBanner;
